import { posUrl } from "../Config/Url";
import axios from "axios";
import { globalUrl } from "../Config/Url";
export const posServices = {
  get,
  getById,
  getSearch,
  create,
  update,
  deletePos,
  invoicePos,
  deactivatePos,
  changePos,
  transferPos,
  reactivatePos,
  suspendPos,
  unsuspendPos,
  changeDocumentNumber,
  changePosTag,
  getPosVersions,
  changePosVersion,
  getPosVersionHistory,
  syncLog,
  syncInvoices,
  unInstallPos,
  clearData
};

async function get() {
  return axios
    .get(posUrl)
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function getById(posId) {
  return axios
    .get(`${posUrl}/${posId}`)
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}
async function getPosVersions(posVersion) {
  const url = posVersion
    ? `${globalUrl}/versions?version=${posVersion}`
    : `${globalUrl}/versions`;

  return axios
    .get(url)
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function getSearch({
  tenantId,
  storeId,
  searchText,
  isDeactivated,
  sortName,
  isAsc,
  pageIndex,
  pageSize,
}) {
  return axios
    .put(`${posUrl}/search`, {
      tenantId,
      storeId,
      searchText,
      isActive: !isDeactivated,
      sortName,
      isAsc,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function create({
  tenantId,
  storeId,
  tag,
  description,
  workingMode,
  documentNumber,
  activatedBy,
  deposit,
  posserialNumber,
  inventoryNumber,
  subscriptionValidFrom,
  //subscriptionValidTo,
  closeArticleSearch,
  multiDraft,
  cashDefault,
  tid,
  msisdn,
  fiscalMode,
  modeId,
  paymentAppId,
  posTypeId,
  terminalName,
  manufacturer,
  model,
  operationSystem
}) {
  return axios
    .post(`${posUrl}`, {
      tenantId,
      storeId,
      tag,
      description,
      workingMode,
      documentNumber,
      activatedBy,
      deposit,
      posserialNumber,
      inventoryNumber,
      subscriptionValidFrom,
      //subscriptionValidTo,
      closeArticleSearch,
      multiDraft,
      cashDefault,
      tid,
      msisdn,
      fiscalMode,
      modeId,
      paymentAppId,
      posTypeId,
      terminalName,
      manufacturer,
      model,
      operationSystem
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function update({
  posId,
  tag,
  description,
  deposit,
  posserialNumber,
  inventoryNumber,
  subscriptionValidFrom,
  //subscriptionValidTo,
  msisdn,
  tid,
  closeArticleSearch,
  multiDraft,
  cashDefault,
  workingMode,
  modeId,
  paymentAppId,
  posTypeId,
  terminalName,
  manufacturer,
  model,
  operationSystem
}) {
  return axios
    .put(`${posUrl}/${posId}`, {
      tag,
      description,
      deposit,
      posserialNumber,
      inventoryNumber,
      subscriptionValidFrom,
      //subscriptionValidTo,
      msisdn,
      tid,
      closeArticleSearch,
      multiDraft,
      cashDefault,
      workingMode,
      modeId,
      paymentAppId,
      posTypeId,
      terminalName,
      manufacturer,
      model,
      operationSystem
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function deletePos(posId) {
  return axios
    .delete(`${posUrl}/${posId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function invoicePos({ tenantId, storeTag, posTag, pageIndex, pageSize }) {
  return axios
    .put(`${posUrl}/state`, {
      tenantId,
      storeTag,
      posTag,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function deactivatePos(posId, noteId, note) {
  return axios
    .patch(`${posUrl}/${posId}/deactivate`, { noteId, note })
    .then((res) => res)
    .catch((err) => err.response);
}

async function reactivatePos(posId) {
  return axios
    .patch(`${posUrl}/${posId}/reactivate`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function suspendPos(posId, suspensionNote) {
  return axios
    .patch(`${posUrl}/${posId}/suspend`, {
      suspensionNote,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function unInstallPos(posId, note) {
  return axios
    .patch(`${posUrl}/${posId}/unInstall`, {
      note,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function unsuspendPos(posId) {
  return axios
    .patch(`${posUrl}/${posId}/Unsuspend`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function changePos(
  posId,
  posSerialNumber,
  inventoryNumber,
  //tid,
  msisdn,
  note,
  noteId,
  generateNewActivationCode
) {
  return axios
    .put(`${posUrl}/${posId}/change`, {
      posSerialNumber,
      inventoryNumber,
      //tid,
      msisdn,
      noteId,
      note,
      generateNewActivationCode,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function transferPos(posId, newStoreId, tag, documentNumber) {
  return axios
    .put(`${posUrl}/${posId}/transfer`, {
      newStoreId,
      tag,
      documentNumber,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function changeDocumentNumber(posId, documentNumber) {
  return axios
    .patch(`${posUrl}/${posId}/changeDocumentNumber`, {
      documentNumber,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function changePosTag(posId, posTag, documentNumber) {
  return axios
    .patch(`${posUrl}/${posId}/changeTag`, {
      posTag,
      documentNumber,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function changePosVersion(posId, posVersionId) {
  return axios
    .put(`${posUrl}/${posId}/change-version`, {
      posVersionId
    ,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function getPosVersionHistory(posId) {
  return axios
    .get(`${posUrl}/${posId}/version-history`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function syncLog(posId) {
  return axios
    .get(`${posUrl}/${posId}/sync-log`)
    .then((res) => res)
    .catch((err) => err.response);
}
async function syncInvoices(posId) {
  return axios
    .get(`${posUrl}/${posId}/sync-invoices`)
    .then((res) => res)
    .catch((err) => err.response);
}
async function clearData(posId) {
  return axios
    .put(`${posUrl}/${posId}/clear-data`)
    .then((res) => res)
    .catch((err) => err.response);
}